<template>
  <service-type-card :id="id"/>
</template>

<script>
import ServiceTypeCard from "@/components/app/service-types/ServiceTypeCard.vue";

export default {
  name: "ServiceType",
  components: {
    ServiceTypeCard
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    isCreating() {
      return this.id === 'create'
    },
    isShowing() {
      return !this.isCreating
    }
  },
}
</script>

<style scoped>

</style>
